import config from './config'

export const defaultCardArt = `${config.ASSETS_HOST}/assets/cardArt/syf_generic_card.svg`
export const synchronyLogo = `${config.ASSETS_HOST}/assets/synchrony/logo.svg`
